export const DEFAULT_SEARCH_SETTINGS = {
  defaultOccupants: {
    adults: 2,
    children: 0,
    childrenAge: [],
    childrenBirthDate: [],
    infants: 0,
  },
  mapView: {
    pinLimit: 20,
    additionalPins: 10,
    /** Desktop max pins after viewport filter (map-offer + list). */
    maxVisiblePins: 60,
  },
}

interface MapViewSettings {
  pinLimit: number
  additionalPins: number
  maxVisiblePins?: number
}

/** List page size for map search (always pinLimit / 20). */
export function getMapSearchPageSize(
  mapView: MapViewSettings = DEFAULT_SEARCH_SETTINGS.mapView,
): number {
  return mapView.pinLimit ?? 20
}

/** Marker cap: desktop uses maxVisiblePins (60); smaller screens use pageSize + additionalPins. */
export function getMapSearchMarkerCap(
  pageSize: number,
  mapView: MapViewSettings = DEFAULT_SEARCH_SETTINGS.mapView,
  decoupledMapPins: boolean = false,
): number {
  if (decoupledMapPins) {
    return mapView.maxVisiblePins ?? pageSize + mapView.additionalPins
  }
  return pageSize + mapView.additionalPins
}
